import React from "react";
import styles from "./footer.module.css";
import LogoWhite from "../../img/LogoWhite.png";
import { Link } from "react-router-dom";
import {
  AiOutlineInstagram,
  AiFillTwitterSquare,
  AiFillFacebook,
} from "react-icons/ai";
import Swal from "sweetalert2";

function Footer() {
  function pageNotYet() {
    Toast.fire({
      title: `Proyecto en desarrollo, este componente aún no fue creado`,
    });
  }

  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  return (
    <div className={styles.footer}>
      <div className={styles.footerBody}>
        <div>
          <img src={LogoWhite} alt="Paca" className={styles.footerImage} />
        </div>

        <div className={styles.company}>
          <p
            style={{
              color: "white",
              fontSize: "1rem",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Compañía
          </p>
          <Link to="/products" className={styles.links}>
            Catálogo
          </Link>
          <Link to="/about" className={styles.links}>
            Sobre este proyecto
          </Link>
          <Link to="/contact" className={styles.links}>
            Ubicación
          </Link>
        </div>

        <div className={styles.legal}>
          <p
            style={{
              color: "white",
              fontSize: "1rem",
              fontWeight: "700",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            Legal
          </p>
          <Link to="/" onClick={() => pageNotYet()} className={styles.links}>
            Términos y condiciones
          </Link>
          <Link to="/" onClick={() => pageNotYet()} className={styles.links}>
            Reembolsos y devoluciones
          </Link>
          <Link to="/" onClick={() => pageNotYet()} className={styles.links}>
            Licencias
          </Link>
        </div>

        <div className={styles.buscanos}>
          <p
            style={{
              color: "white",
              fontSize: "1rem",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            ¡Buscanos!
          </p>
          <Link to="/" onClick={() => pageNotYet()} className={styles.icons}>
            <AiOutlineInstagram />
          </Link>
          <Link to="/" onClick={() => pageNotYet()} className={styles.icons}>
            <AiFillFacebook />
          </Link>
          <Link to="/" onClick={() => pageNotYet()} className={styles.icons}>
            <AiFillTwitterSquare />
          </Link>
        </div>

        <div className={styles.sumate}>
          <p
            style={{
              color: "white",
              fontSize: "1rem",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Sumate a nuestro newsletter
          </p>
          <p className={styles.links}>
            Las mejores ofertas y novedades van por mail
          </p>
          <div className="d-flex">
            <input type="text" className={styles.input} />
            <button className={styles.btnSuscribe} onClick={() => pageNotYet()}>
              Suscribirme
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footerCopyrights}>
        Copyright © 2022 All rights reserved | Paca.Uy
      </div>
    </div>
  );
}

export default Footer;
